/**
 * EINE PDF ÖFFNET IM PROGRAMM DES GERÄTS, NICHT IN DER PLATTFORM (.234).
 *
 * ORIGINALTEXT MARVIN (26.09.2026, 2 Bilder vom iPhone)
 *   „in deinem Betrachter fehlt die erste Seite und bei der 2. Ansicht komme
 *    ich nicht mehr aus dem pdf Betrachter raus wenn ich es geöffnet habe.
 *    Entferne die Einbettung und öffne es ganz normal mit den Standard
 *    Programmen. Auch am Tablet und pc. Überall."
 *
 * DREI ANLÄUFE MIT EINGEBETTETEN PDFS SIND GESCHEITERT (eigener Streifen,
 * `<iframe>`, Seitenbilder). Jetzt gibt es keine Einbettung mehr: die Datei
 * geht in einem neuen Fenster auf, und dort zeigt sie das Gerät mit dem, was
 * es dafür hat - am PC der PDF-Betrachter des Browsers, auf iPhone und iPad
 * die Vorschau von Safari mit „Fertig" oben.
 *
 * WARUM MAN AUF DEM IPHONE NICHT MEHR HERAUSKAM: die Plattform ist dort als
 * App auf dem Home-Bildschirm installiert, und alles, was im Bereich der App
 * liegt (bis .233: die ganze Seite, „/"), öffnet iOS IN der App, ohne
 * Zurück-Knopf. Seit .234 umfasst der Bereich nur noch `/index.html`
 * (`manifest.webmanifest`); eine Datei unter `/api/...` liegt damit
 * ausserhalb, und iOS zeigt sie in einem eigenen Fenster mit „Fertig".
 */

/** Öffnet eine Adresse in einem neuen Fenster, ausserhalb der Plattform. */
export function extern(adresse: string): void {
  /* EIN KLICK, EIN FENSTER (.248).
     ORIGINALTEXT MARVIN (28.09.2026, 2 Tabs „AAZ_5702101_2026-09-28.pdf")
       „irgendwo ist da ein fehler. denn er öffnet zwei mal die datei wenn ich
        drauf klicke. bitte bei allen dateien prüfen und fehler beheben."
     Hier stand `window.open(adresse, '_blank', 'noopener')`. Mit `noopener`
     gibt der Browser laut Norm IMMER `null` zurück - auch wenn das Fenster
     aufging. Der Ausweg darunter hielt das für „blockiert" und öffnete die
     Datei ein zweites Mal. Jetzt ohne das Merkmal; die Verbindung zur
     Plattform wird danach von Hand gekappt (`opener = null`). */
  const w = window.open(adresse, '_blank');
  if (w) {
    try { w.opener = null; } catch { /* manche Browser lassen es nicht zu */ }
    return;
  }
  /* WIRKLICH BLOCKIERT: ein Verweis, der angeklickt wird, geht durch. */
  const a = document.createElement('a');
  a.href = adresse; a.target = '_blank'; a.rel = 'noopener noreferrer';
  document.body.appendChild(a); a.click(); a.remove();
}

/**
 * Dasselbe für eine Adresse, die erst noch entsteht (eine Vorschau vom
 * Server). DAS FENSTER GEHT SOFORT AUF, sonst hält der Browser es für ein
 * ungebetenes Fenster und blockiert es.
 */
export async function externSpaeter(hole: () => Promise<string>): Promise<void> {
  const w = window.open('', '_blank');
  try {
    const adresse = await hole();
    if (w) w.location.href = adresse; else extern(adresse);
  } catch (f) {
    w?.close();
    throw f;
  }
}

/** Ist das eine PDF? Nach Art, sonst nach Endung. */
export function istPdfDatei(mime: string | null | undefined, name: string | null | undefined): boolean {
  return /pdf/i.test(String(mime ?? '')) || /\.pdf$/i.test(String(name ?? ''));
}
